import ModelTypeConstants from 'constants/ModelTypeConstants';
import {BioentityAliasInfo} from 'constants/RegistryConstants';
import EntityStore from 'stores/EntityStore';
import sortedBy from 'util/sortedBy';

export function hasOrgCollection(bioentityAliasInfos: Array<BioentityAliasInfo>): boolean {
  return bioentityAliasInfos.some(
    (bioentityAliasInfo) =>
      bioentityAliasInfo.registryCollectionOwner &&
      bioentityAliasInfo.registryCollectionOwner.type === ModelTypeConstants.ORGANIZATION
  );
}

export function hasPersonalCollection(bioentityAliasInfos: Array<BioentityAliasInfo>): boolean {
  const currentUser = EntityStore.currentUser();
  if (!currentUser) {
    return false;
  }
  return bioentityAliasInfos.some(
    (bioentityAliasInfo) =>
      bioentityAliasInfo.registryCollectionOwner &&
      bioentityAliasInfo.registryCollectionOwner.id === currentUser.id
  );
}

export function getAliasesToDisplay(
  name: string,
  bioentityAliasInfos: Array<BioentityAliasInfo>
): Array<string> {
  const bioentityAliasInfosToDisplay = bioentityAliasInfos.filter(
    (bioentityAliasInfo) => bioentityAliasInfo.alias !== name
  );
  const sortedBioentityAliasInfos = sortedBy(bioentityAliasInfosToDisplay, [
    (bioentityAliasInfo) =>
      Number(
        !(
          bioentityAliasInfo.registryCollectionOwner &&
          bioentityAliasInfo.registryCollectionOwner.id === EntityStore.currentUser().id
        )
      ),
  ]);
  return sortedBioentityAliasInfos.map((bioentityAliasInfo) => bioentityAliasInfo.alias);
}
